import { Navigate } from "react-router-dom";
import { useAuth } from "contexts/auth";
import { TUserRole } from "configs/routes";

type Props = {
  permissions?: TUserRole[];
  children: React.ReactNode;
};

export const PermissionRoute = ({ permissions, children }: Props) => {
  const { user } = useAuth();
  const userRoleNames = user?.roles?.map((r) => r.name) ?? [];

  if (permissions?.length && !permissions.some((p) => userRoleNames.includes(p))) {
    return <Navigate to="/dashboard/overview" replace />;
  }

  return <>{children}</>;
};
